import PropTypes from 'prop-types';

import Card from '@zenbusiness/zui/Card';
import CardContent from '@zenbusiness/zui/CardContent';
import CardHeader from '@zenbusiness/zui/CardHeader';
import Divider from '@zenbusiness/zui/Divider';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';

import { Badge } from './components/Badge';
import { CardButton, CardLink } from './components/FauxComponent';
import { Footer } from './components/Footer';
import * as Styled from './ProductCard.style';

function ProductCard({
  categories,
  description,
  estimate,
  eventProps,
  imageUrl,
  onClick,
  partnerImageUrl,
  primaryCta,
  product,
  status,
  title
}) {
  const clickstreamProps = {
    elementName: 'product_card_cta',
    elementPosition: 'product_cards',
    ...eventProps
  };

  return (
    <Card interactive>
      {primaryCta?.url && (
      <CardLink
        clicksreamProps={clickstreamProps}
        title={title}
        url={primaryCta?.url}
      />
      )}

      {!primaryCta?.url && primaryCta?.modalName && (
      <CardButton
        clicksreamProps={clickstreamProps}
        modalName={primaryCta?.modalName}
        onClick={onClick}
        title={title}
      />
      )}
      <Badge badge={status} />
      <CardContent>
        <Stack gap={2}>
          <Stack gap={2} horizontal sx={{ justifyContent: 'space-between' }}>
            <CardHeader subtitle={description} title={title} />
            <Styled.LogoContainer>
              <SharedAsset alt="" src={imageUrl} width="5rem" />
            </Styled.LogoContainer>
          </Stack>
          <Divider />
          <Footer
            categories={categories}
            estimate={estimate}
            partnerImageUrl={partnerImageUrl}
            product={product}
            status={status}
            url={primaryCta?.url}
          />
        </Stack>
      </CardContent>
    </Card>
  );
}

ProductCard.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      state: PropTypes.string
    })
  ),
  description: PropTypes.string.isRequired,
  estimate: PropTypes.string,
  eventProps: PropTypes.shape({}),
  imageUrl: PropTypes.string.isRequired,
  partnerImageUrl: PropTypes.string,
  primaryCta: PropTypes.shape({
    label: PropTypes.string,
    modalName: PropTypes.string,
    url: PropTypes.string
  }),
  product: PropTypes.shape({
    pricing: PropTypes.shape({
      amount: PropTypes.number,
      formattedPricePerInterval: PropTypes.string
    }),
    name: PropTypes.string,
    service: PropTypes.string,
    uuid: PropTypes.string
  }),
  onClick: PropTypes.func,
  status: PropTypes.shape({
    state: PropTypes.string
  }),
  title: PropTypes.string.isRequired
};

export default ProductCard;
